/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługuje moduł PVI
 * * Obiekt musi być zadeklarowany po załadowaniu DOM
 *
 * @export
 * @class Pvi
 */

export class Pvi {
	constructor(mainContID, singleContClass, productNameMaxLines) {
		this.cont = $('#' + mainContID);
		this.list = $('.' + singleContClass);
		this.singleCont = singleContClass;
		this.mainCont = mainContID;
		this.mainContFU = mainContID.charAt(0).toUpperCase() + mainContID.slice(1);
		this.currentIndex = 1;
		this.productsCount = Number(this.cont.attr('data-products-count'));
		this.productNameContHeight = 0;
		this.productNameMaxLines = productNameMaxLines;
		this.actualView = null;
		var productsCountPerLineArray = this.cont.attr('data-max-product-count-per-line').split(',');
		var productsCountPerLineTmp = [];
		productsCountPerLineTmp[0] = Number(productsCountPerLineArray[0]);
		productsCountPerLineTmp[1] = Number(productsCountPerLineArray[1]);
		productsCountPerLineTmp[2] = Number(productsCountPerLineArray[2]);
		productsCountPerLineTmp[3] = Number(productsCountPerLineArray[3]);
		productsCountPerLineTmp[4] = Number(productsCountPerLineArray[4]);
		this.productsCountPerLine = productsCountPerLineTmp;
		this.init();
	}
	active() {
		return this.cont.length > 0;
	}
	// ****************************************************************************************************
	// Inicjalizacja kafelkow PVI
	// ****************************************************************************************************
	init() {
		if (this.active()) { // tylko dla istniejących kontenerow PVI
			this.calculateProductNameContHeight();
			this.preperPviCont();
			//this.adjustNameContHeight();
			this.initPviFadeIn();
			this.initPviDetails();
			this.initPviBtns();
			this.update(true);
		}
	}
	// ****************************************************************************************************
	// Aktualizujaca kafelkow PVI względem bootstrapSize
	// ****************************************************************************************************
	update(initMode) {
		var that = this;
		if (this.active()) { // tylko dla istniejących kontenerow PVI
			if (!initMode)
				this.adjustAllNameContHeight();
			if (pageObj.settings.bootstrap.kind == 'desktop')
				this.changePviToDesktopView();
			if (pageObj.settings.bootstrap.kind == 'mobile')
				this.changePviToMobileView();
		}
	}
	// ****************************************************************************************************
	// Obliczenie wys nazwy
	// ****************************************************************************************************
	calculateProductNameContHeight() {
		var that = this;
		that.list.each(function (i, e) {
			$(e).find('.productName a').html(function () {
				if (that.productNameContHeight === 0) { // obliczenie wysokości względem ilości linii
					var testString = '';
					var htmlSave = $(this).html();
					for (var i = 1; i < that.productNameMaxLines; i++) {
						testString += i + '<br>';
					}
					$(this).html(testString + that.productNameMaxLines);
					that.productNameContHeight = $(this).height();
					$(this).html(htmlSave);
				}
			});
			return false;
		});
	}
	// ****************************************************************************************************
	// Ustawienie wysokości nazwy
	// ****************************************************************************************************
	adjustNameContHeight(e) {
		var that = this;
		var nCont = $(e).find('.productName a');
		if (!nCont.data('oryginalHtm'))
			nCont.data('oryginalHtm', nCont.html());
		else
			nCont.html(nCont.data('oryginalHtm')).removeAttr('style');
		toolsObj.adjustStringToElHeight(nCont, that.productNameMaxLines, that.productNameContHeight);
	}
	// ****************************************************************************************************
	// Ustawienie wszystkich wysokości nazw
	// ****************************************************************************************************
	adjustAllNameContHeight() {
		var that = this;
		that.list.each(function (i, e) {
			//that.adjustNameContHeight(e);
		});
	}
	// ****************************************************************************************************
	// Ustawienie kafelków PVI pod kątem widoczności wg bootstrapSize
	// ****************************************************************************************************
	preperPviCont() {
		var that = this;
		this.list.each(function (i, e) {
			$(e).removeClass('visibility-collapse');
			that.adjustNameContHeight(e);
			if (i >= that.productsCountPerLine[pageObj.settings.bootstrap.size]) {
				$(e).hide().removeClass('transparent').removeClass('fadeInQueue');
				$('#img-' + that.mainCont + '-' + $(e).attr('data-product-id')).removeClass('waitForLoadingDeleyFadeIn');
			}
		});
	}
	// ****************************************************************************************************
	// Przełączenie/aktualizacja kafelków PVI w tryp MOBILE
	// ****************************************************************************************************
	changePviToMobileView() {
		var that = this;
		var min_cont_width = PVI_MIN_SW; // minimalną szerokość determinuje cena (nie może się łamać) - ten parametr pozwala zwiększyć szerokość konternera ponad to minmimum
		var cols = $('#' + that.mainCont + 'Row').attr('data-cols').split(' ');
		var totalWidth = 0;
		if ( that.actualView != "mobile" )
			that.currentIndex = 1;

		$('#' + that.mainCont + 'Row').removeAttr('style').addClass('row'); // zresetowanie kontenera 'Row'
		for (var i = 0; i < cols.length; i++) {
			$('.' + that.singleCont).addClass(cols[i]); // ustawienie class 'col-'
		}
//		$('#' + that.mainCont + ' .pviScrollBtn').removeClass('d-flex').addClass('d-none'); // ukrywa przyciski NEXT i PREV
		$('#' + that.mainCont + ' .pviScrollBtn').addClass('d-flex').removeClass('d-none'); // pokazuje przyciski NEXT i PREV
		$('#' + that.mainCont + 'BtnFix .pviScrollBtn').addClass('d-flex').removeClass('d-none'); // wersja alternatywny przy przenoszeniu BTNs
		that.fixElementsHeight();
		$('.' + that.singleCont).each(function (i, e) {
			var realW = toolsObj.realWidth($(e));
			var difW = realW - $(e).width();
			if ( realW < min_cont_width ){
				realW = min_cont_width;
			}
			totalWidth += realW + difW; // wyliczenie szer dla 'Row'
			$(e).width(realW); // zapamietanie ustawienia szer kafelka
		});
		$('#' + that.mainCont + 'Row').removeClass('row').width(totalWidth); // podstawienie szerokosci 'Row'
		for (var i = 0; i < cols.length; i++) {
			$('.' + that.singleCont).removeClass(cols[i]); // wyczyszczenie class 'col-'
		}
		that.list.show(); // pokazanie wszystkich kafelków
		toolsObj.setImg(); // przeliczenie rozmiaru obrazków
		that.actualView = "mobile";
	}
	// ****************************************************************************************************
	// Przełączenie/aktualizacja kafelków PVI w tryp DESKTOP
	// ****************************************************************************************************
	changePviToDesktopView() {
		var that = this;
		var cols = $('#' + that.mainCont + 'Row').attr('data-cols').split(' ');
		if ( that.actualView != "desktop" )
			that.currentIndex = 1;

		if ( that.productsCountPerLine[pageObj.settings.bootstrap.size] < that.productsCount ) {
			$('#' + that.mainCont + ' .pviScrollBtn').removeClass('d-none').addClass('d-flex'); // pokazuje przyciski NEXT i PREV
			$('#' + that.mainCont + 'BtnFix .pviScrollBtn').removeClass('d-none').addClass('d-flex'); // wersja alternatywny przy przenoszeniu BTNs
		} else {
			$('#' + that.mainCont + ' .pviScrollBtn').removeClass('d-flex').addClass('d-none'); // ukrywa przyciski NEXT i PREV
			$('#' + that.mainCont + 'BtnFix .pviScrollBtn').removeClass('d-flex').addClass('d-none'); // wersja alternatywny przy przenoszeniu BTNs
		}
		$('.' + that.singleCont).each(function (i, e) {
			$(e).removeAttr('style'); // zresetowanie ustawien kafelka
		});
		for (var i = 0; i < cols.length; i++) {
			$('.' + that.singleCont).addClass(cols[i]); // ustawienie class 'col-'
		}
		$('#' + that.mainCont + 'Row').removeAttr('style').addClass('row'); // zresetowanie kontenera 'Row'
		// widocznosc - pokazanie kafelków wg bootstrap
		that.list.each(function (i, e) {
			$(e).attr('id', that.singleCont + '-' + (i + 1)); // ponowne nadanie ID ze względu na wycinanie towary z TD (np promocja na podstawie TD ale nie wys. jako TD)
			if (i < that.productsCountPerLine[pageObj.settings.bootstrap.size]) {
				if ($(e).hasClass('visibility-collapse'))
					$(e).removeClass('visibility-collapse');
				$(e).appendTo('#' + that.mainCont + 'Row').show();
			}
			else {
				$(e).hide().appendTo('#' + that.mainCont + 'Row');
			}
		});
		toolsObj.setImg(); // przeliczenie rozmiaru obrazków
		that.actualView = "desktop";
	}
	// ****************************************************************************************************
	// Wyrównanie wysokości elementow po: data-height-fix-group
	// ****************************************************************************************************
	fixElementsHeight() {
		toolsObj.alignElementsHeight(this.singleCont);
	}
	// ****************************************************************************************************
	// Inicjalizacja animacji fadeIn kafelków PVI
	// ****************************************************************************************************
	initPviFadeIn() {
		var that = this;
		toolsObj.waitForLoadingObjects('#' + this.mainCont + ' img.waitForLoadingDeleyFadeIn', function () {
			var fadeInQueueElements = $('#' + this.mainCont + ' .fadeInQueue');
			var fadeInQueueElementsCount = fadeInQueueElements.length;
			toolsObj.setImg('img.img' + this.mainContFU);
			this.fixElementsHeight();
			fadeInQueueElements.each(function (i, e) {
				setTimeout(function () {
					$(e).fadeTo(EFFECTS_SPEED, 1).removeClass('transparent');
					if ( fadeInQueueElementsCount == (i + 1) ) { // && pageObj.settings.bootstrap.kind == 'desktop' -
						if ( this.productsCountPerLine[pageObj.settings.bootstrap.size] < this.productsCount ) {
							// $('#' + this.mainCont + ' .pviScrollBtn').removeClass('d-none').addClass('d-flex'); // ukryw przyciski NEXT i PREV
						}
					}
				}.bind(this), FADE_IN_QUEUE_DELAY + (FADE_IN_QUEUE_STEP * Number(i)));
			}.bind(this));
		}.bind(this));
	}
	// ****************************************************************************************************
	// Obsługa animacji wejścia szczegołów w kafelku PVI
	// ****************************************************************************************************
	initPviDetails() {
		var that = this;
		$('#' + that.mainCont + ' .animateEntryFromLeft').each(function (i, e) {
			var canClose = true;
			var animateEntryFromLeftTimer;
			$(e).on('click', function (event) {
				event.stopPropagation();
				location.href = $(e).children('.productCode').children('a').attr('href');
			}).parent().mouseenter(function () {
				if (pageObj.settings.bootstrap.kind == 'desktop') {
					$(e).find('.productName a').html(function () {
						toolsObj.adjustStringToElHeight($(this), that.productNameMaxLines, that.productNameContHeight);
						$(this).height(that.productNameContHeight); // wyrównanie wysokości elementów
					});
					$(e).animate({
						left: 0
					}, PRODUCTS_DETEILS_ANIMATION_SPEED);
				}
			}).mouseout(function () {
				if (pageObj.settings.bootstrap.kind == 'desktop') {
					animateEntryFromLeftTimer = setTimeout(function () {
						$(e).animate({
							left: '-110%'
						}, PRODUCTS_DETEILS_ANIMATION_SPEED);
					}, PRODUCTS_DETEILS_LIFE_TIME);
				}
			}).mouseover(function () {
				clearTimeout(animateEntryFromLeftTimer);
			}).on('click', function () {
				if (pageObj.settings.bootstrap.kind == 'mobile' && false) { // model gdy otwierana jest karta ze szczegołami
					canClose = ($(e).hasClass('active')) ? false : true;
					$(e).find('.productName a').html(function () {
						toolsObj.adjustStringToElHeight($(this), that.productNameMaxLines, that.productNameContHeight);
						$(this).height(that.productNameContHeight); // wyrównanie wysokości elementów
					});
					$('.animateEntryFromLeft.active').animate({
						left: '-110%'
					}, PRODUCTS_DETEILS_ANIMATION_SPEED).removeClass('active');
					if (canClose) {
						$(e).animate({
							left: 0
						}, PRODUCTS_DETEILS_ANIMATION_SPEED);
						$(e).addClass('active');
					}
				}
				else if (pageObj.settings.bootstrap.kind == 'mobile') { // wersja -> klik = podstrona towaru
					location.href = $(e).children('.productCode').children('a').attr('href');
				}
			});
			$(e).find('.inputQuantity, .btnAddToCart, .btnAddToClipboard').click(function (event) {
				event.stopPropagation();
			});
			if ($(this).is(':visible')) {
				$(e).find('.productName a').html(function () {
					if (that.productNameContHeight === 0) { // obliczenie wysokości względem ilości linii
						var testString = '';
						var htmlSave = $(this).html();
						for (var i = 1; i < that.productNameMaxLines; i++) {
							testString += i + '<br>';
						}
						$(this).html(testString + that.productNameMaxLines);
						that.productNameContHeight = $(this).height();
						$(this).html(htmlSave);
					}
					toolsObj.adjustStringToElHeight($(this), that.productNameMaxLines, that.productNameContHeight);
					$(this).height(that.productNameContHeight); // wyrównanie wysokości elementów
				});
			}
		});
	}
	// ****************************************************************************************************
	// Obsługa przyciskow PVI (NEXT, PREV)
	// ****************************************************************************************************
	initPviBtns() {
		var that = this;
		// var obj;
		// for (var i = 1; i <= that.productsCount; i++) {
		// 	obj =  $('#' + that.singleCont + '-' + i + ' .productCode a');
		// 	obj.html("("+i+")"+obj.html());
		// }

		$('#' + that.mainCont + ' .pviScrollNextBtn').on('click', function () {
//console.log("pviScrollNextBtn", that.singleCont );
			var countPerLine =  that.productsCountPerLine[pageObj.settings.bootstrap.size];
			var nextIndex = that.currentIndex + countPerLine;

			if ( nextIndex > that.productsCount ) {
				nextIndex -= that.productsCount;
			}

			$('#' + that.singleCont + '-' + that.currentIndex).appendTo('#' + that.mainCont + 'Row');

			if ( that.actualView != "mobile" )
				$('#' + that.singleCont + '-' + that.currentIndex).hide();

			$('#' + that.singleCont + '-' + nextIndex).show(0, function(){
				toolsObj.setImg('img.img' + that.mainContFU);
			});

			that.currentIndex++;
			if (that.currentIndex > that.productsCount) {
				that.currentIndex = 1;
			}

			// HOTFIX - odkrywa przysłonięte elementy... ale niestey powoduje skoki
			toolsObj.alignElementsHeight(that.singleCont);
		});

		$('#' + that.mainCont + ' .pviScrollPrevBtn').on('click', function () {
//console.log("pviScrollPrevBtn", that.singleCont);
			var countPerLine =  that.productsCountPerLine[pageObj.settings.bootstrap.size];
			var indexToHide = that.currentIndex + countPerLine - 1; // do pokazania
			if ( indexToHide > that.productsCount ) {
				indexToHide -= that.productsCount;
			}

			var indexToShow = that.currentIndex + that.productsCount - 1; // do pokazania
			if ( indexToShow > that.productsCount ) {
				indexToShow -= that.productsCount;
			}


			if ( that.actualView != "mobile" )
				$('#' + that.singleCont + '-' + indexToHide).hide();

			$('#' + that.singleCont + '-' + indexToShow).prependTo('#' + that.mainCont + 'Row').show(0, function(){
				toolsObj.setImg('img.img' + that.mainContFU);
			});

			that.currentIndex--;
			if ( that.currentIndex < 1 ) {
				that.currentIndex = that.productsCount;
			}

			// HOTFIX - odkrywa przysłonięte elementy... ale niestey powoduje skoki
			toolsObj.alignElementsHeight(that.singleCont);
		});
		that.fixPviBtnsPosition();
	}


	// ****************************************************************************************************
	// Poprawienie wyświetlania pozycji przycisków (na mobile umożliwia prełaczanie kafelkow)
	// ****************************************************************************************************
	fixPviBtnsPosition(){
//console.log("fixPviBtnsPosition");
		let pvi = $('#' + this.mainCont);
		$('<div id="'+this.mainCont+'BtnFix" class="scrollBtnFix position-relative"></div>').insertBefore(pvi);
		let fixBox = $('#' + this.mainCont+'BtnFix');
		pvi.appendTo(fixBox);
		$('#' + this.mainCont + ' .pviScrollBtn').appendTo(fixBox);
	}

	// ****************************************************************************************************
	// Obsługa przyciskow PVI (NEXT, PREV) KOPIA 28.06
	// ****************************************************************************************************
	initPviBtnsCopy() {
		var that = this;
		$('#' + this.mainCont + ' .pviScrollNextBtn').on('click', function () {
			$('#' + this.singleCont + '-' + this.currentIndex).hide(0, function () {
				var indexNext = this.currentIndex + this.productsCountPerLine[pageObj.settings.bootstrap.size];
				if (indexNext > this.productsCount)
					indexNext -= this.productsCount;
				if ($('#' + this.singleCont + '-' + indexNext).hasClass('visibility-collapse'))
					$('#' + this.singleCont + '-' + indexNext).removeClass('visibility-collapse');
				$('#' + this.singleCont + '-' + indexNext).appendTo('#' + this.mainCont + 'Row').show(0, function () {
					toolsObj.setImg('img.img' + this.mainContFU); // czy to jest potrzebne?
					this.currentIndex++;
					if (this.currentIndex > this.productsCount)
						this.currentIndex = 1;
				}.bind(this));
			}.bind(this)).appendTo('#' + this.mainCont + 'Row');
		}.bind(this));
		$('#' + this.mainCont + ' .pviScrollPrevBtn').on('click', function () {
			var indexPrev = this.currentIndex + this.productsCountPerLine[pageObj.settings.bootstrap.size] - 1;
			if (indexPrev > this.productsCount)
				indexPrev -= this.productsCount;
			$('#' + this.singleCont + '-' + indexPrev).hide(0, function () {
				var indexPrev = this.currentIndex - 1;
				if (indexPrev < 1)
					indexPrev = this.productsCount;
				if ($('#' + this.singleCont + '-' + indexPrev).hasClass('visibility-collapse'))
					$('#' + this.singleCont + '-' + indexPrev).removeClass('visibility-collapse');
				$('#' + this.singleCont + '-' + indexPrev).prependTo('#' + this.mainCont + 'Row').show(0, function () {
					toolsObj.setImg('img.img' + this.mainContFU); // czy to jest potrzebne?
					this.currentIndex--;
					if (this.currentIndex < 1)
						this.currentIndex = this.productsCount;
				}.bind(this));
			}.bind(this)).appendTo('#' + this.mainCont + 'Row');
		}.bind(this));
	}
}